export default __webpack_public_path__ + "static/media/logoImpactoolsOperacao.83a4afad.svg";